import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../services/api";

// ─────────────────────────────────────────────
// Get Wallet Balance
// ─────────────────────────────────────────────

export const fetchWalletBalance = createAsyncThunk(
    "wallet/fetchWalletBalance",

    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.post(
                "/wallet/balance",
                payload
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch wallet balance"
            );
        }
    }
);


// ─────────────────────────────────────────────
// Get Wallet History
// ─────────────────────────────────────────────

export const fetchWalletHistory = createAsyncThunk(
    "wallet/fetchWalletHistory",

    async ({
        page = 1,
        per_page = 25,
        filterType = null,
        ReferenceNo = null,
        TransactionFromDate = null,
        TransactionToDate = null,
        customer_id = null,
    }, { rejectWithValue }) => {

        try {
            const response = await api.post(
                "/wallet/history",
                {
                    filterData: {
                        filterType,
                        ReferenceNo,
                        TransactionFromDate,
                        TransactionToDate,
                    },
                    customer_id,
                },
                {
                    params: {
                        page,
                        per_page,
                    },
                }
            );

            const data = response.data;

            return {
                history: data.data || data,
                totalPages: data.last_page || 1,
            };

        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch wallet history"
            );
        }
    }
);


// ─────────────────────────────────────────────
// Slice
// ─────────────────────────────────────────────

const walletSlice = createSlice({
    name: "wallet",

    initialState: {
        balance: null,
        history: [],
        totalPages: 1,

        balanceLoading: false,
        historyLoading: false,

        error: "",
    },

    reducers: {},

    extraReducers: (builder) => {

        // ───────── Wallet Balance ─────────

        builder
            .addCase(fetchWalletBalance.pending, (state) => {
                state.balanceLoading = true;
                state.error = "";
            })

            .addCase(fetchWalletBalance.fulfilled, (state, action) => {
                state.balance = action.payload;
                state.balanceLoading = false;
            })

            .addCase(fetchWalletBalance.rejected, (state, action) => {
                state.balanceLoading = false;
                state.error = action.payload;
            });


        // ───────── Wallet History ─────────

        builder
            .addCase(fetchWalletHistory.pending, (state) => {
                state.historyLoading = true;
                state.error = "";
            })

            .addCase(fetchWalletHistory.fulfilled, (state, action) => {
                state.history = action.payload.history;
                state.totalPages = action.payload.totalPages;
                state.historyLoading = false;
            })

            .addCase(fetchWalletHistory.rejected, (state, action) => {
                state.historyLoading = false;
                state.error = action.payload;
            });
    },
});

export default walletSlice.reducer;